import './polyfill';
// tslint:disable-next-line: ordered-imports / 先頭でPolyfill
import { MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider, ReactReduxContext } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';

import { AnyAction } from 'typescript-fsa';

import App from './App';
import { dependencies, rootEpic } from './epics';
import './index.css';
import createRootReducer, { IRootState } from './reducers';
import registerServiceWorker from './registerServiceWorker';
import themeDefinition from './theme';

declare global {
	// tslint:disable-next-line:interface-name // "Window"は既存のインタフェース名
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
	}
}

const theme = createMuiTheme(themeDefinition);
const history = createBrowserHistory();

// Middleware
// router
const router = routerMiddleware(history);

// epic
const epicMiddleware = createEpicMiddleware<
	AnyAction,
	AnyAction,
	IRootState,
	typeof dependencies
>({ dependencies });

// compose
const composeEnhancers =
	(window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const enhancer = composeEnhancers(applyMiddleware(router, epicMiddleware));

// store
const store = createStore(createRootReducer(history), enhancer);

epicMiddleware.run(rootEpic);

ReactDOM.render(
	<Provider store={store} context={ReactReduxContext}>
		<MuiThemeProvider theme={theme}>
			<ConnectedRouter history={history} context={ReactReduxContext}>
				<App />
			</ConnectedRouter>
		</MuiThemeProvider>
	</Provider>,
	document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx